import React, { ReactNode } from 'react';

import { Box } from 'components/library';

const SubscriptionCardWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Box $mb={20} $paddingX={16} $paddingTop={16} $borderRadius={12} $paddingBottom={16} $backgroundColor="surface-default">
      {children}
    </Box>
  );
};

export default SubscriptionCardWrapper;
